import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-shenhe",
  "use": "icon-form-shenhe-usage",
  "viewBox": "0 0 198.4 198.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 198.4 198.4\" id=\"icon-form-shenhe\">\r\n<path d=\"M179.4,159.2H19v-23.9c0-1.2,1-2.2,2.3-2.2h64.6V93.6L82,91.8C67.2,85,57.8,70.4,57.7,54.5c0-12.6,5.8-24.4,16-32.3\r\n\tc10.4-8.1,23.9-11,37.3-7.9c15.4,3.5,28,15.9,31.4,30.9c4.5,20.2-6,39.8-25.5,47.6l-4.2,1.6V133h64.6c1.2,0,2.2,1,2.2,2.2\r\n\tL179.4,159.2L179.4,159.2z M177.2,120H126v-17c22.8-11.3,34.9-36.2,29.4-60.6C151,22.5,134.3,6.1,114,1.5C96.6-2.4,78.9,1.4,65.3,12\r\n\tc-13.3,10.2-21,25.9-21,42.4c0,19.5,10.9,37.5,28.2,47.2V120H21.3c-8.6,0-15.6,6.8-15.6,15.3v37h187.1v-37\r\n\tC192.8,126.8,185.8,120,177.2,120z\" />\r\n<path d=\"M19,198.4h160.4v-13.1H19V198.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-shenhe.svg
// module id = +lrI
// module chunks = 13